var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQoVertWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.3 320.2",
    style: {
      enableBackground: "new 0 0 47.3 320.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#247D91;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    className: "st0",
    width: 8.6,
    height: 266.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,266.5h-8.5v-12h8.5V266.5z M29.8,242.5h-8.5v-12h8.5V242.5z M29.8,218.5h-8.5v-12h8.5V218.5z  M29.8,194.4h-8.5v-12h8.5V194.4z M29.8,170.4h-8.5v-12h8.5V170.4z M29.8,146.4h-8.5v-12h8.5V146.4z M29.8,122.4h-8.5v-12h8.5 V122.4z M29.8,98.4h-8.5v-12h8.5V98.4z M29.8,74.4h-8.5v-12h8.5V74.4z M29.8,50.4h-8.5v-12h8.5V50.4z M29.8,26.4h-8.5v-12h8.5 V26.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21,310.4c-0.6-0.2-1.2-0.7-1.8-1.2c-0.6-0.6-1.3-1.2-1.9-1.9c-0.6-0.7-1.2-1.4-1.7-2c-0.1,0-0.2,0-0.2,0 s-0.2,0-0.4,0c-1.9,0-3.5-0.4-4.6-1.1c-1.2-0.7-2-1.8-2.5-3.1c-0.5-1.4-0.7-3-0.7-4.9V286c0-1.9,0.2-3.4,0.7-4.7 c0.5-1.3,1.3-2.4,2.5-3.1s2.7-1.1,4.6-1.1c2,0,3.5,0.4,4.7,1.1c1.2,0.7,2,1.8,2.5,3.1c0.5,1.3,0.7,3,0.7,4.7v10.3 c0,1.3-0.1,2.5-0.4,3.5c-0.2,1.1-0.7,2-1.2,2.7c-0.6,0.8-1.3,1.4-2.2,1.8c0.2,0.4,0.6,0.6,0.9,0.9c0.4,0.4,0.6,0.7,0.9,0.9 c0.4,0.2,0.6,0.6,0.9,0.7L21,310.4z M15,301.5c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.8,0.8-1.5c0.1-0.6,0.2-1.3,0.2-2.1v-12.7 c0-0.8-0.1-1.4-0.2-2.1c-0.1-0.6-0.4-1.1-0.8-1.4c-0.4-0.4-1.1-0.5-1.9-0.5s-1.4,0.1-1.9,0.5c-0.4,0.4-0.7,0.8-0.8,1.4 c-0.1,0.6-0.2,1.3-0.2,2.1v12.7c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.2,0.8,1.5C13.6,301.4,14.3,301.5,15,301.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.2,310.5c-1.1,0-1.9-0.2-2.6-0.6c-0.7-0.4-1.3-0.9-1.7-1.7c-0.4-0.7-0.6-1.5-0.6-2.6v-5.1 c0-1.1,0.2-1.9,0.6-2.6c0.4-0.7,0.9-1.3,1.7-1.7c0.7-0.4,1.5-0.6,2.6-0.6c1.1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,0.9,1.7,1.7 c0.4,0.7,0.6,1.5,0.6,2.6v5.1c0,1.1-0.2,1.9-0.6,2.6c-0.4,0.7-0.9,1.3-1.7,1.7C32.1,310.2,31.3,310.5,30.2,310.5z M30.2,307.9 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.4-0.7c0.1-0.4,0.1-0.7,0.1-1.1v-5.7c0-0.4,0-0.7-0.1-1.1c0-0.4-0.1-0.6-0.4-0.7 c-0.1-0.2-0.4-0.2-0.7-0.2c-0.4,0-0.6,0.1-0.7,0.2c-0.1,0.2-0.2,0.5-0.4,0.7c0,0.2-0.1,0.6-0.1,1.1v5.7c0,0.4,0,0.7,0.1,1.1 s0.1,0.6,0.4,0.7C29.8,307.9,30,307.9,30.2,307.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoVertWhite);
export default __webpack_public_path__ + "static/media/Qo-Vert-white.ab6aa0fa06951e10477303a19e4dce45.svg";
export { ForwardRef as ReactComponent };